import React from "react";

const YearDropdown = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2024;
  const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push(year);
  }

  return (
    <select className="form-select" defaultValue={currentYear}>
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
  );
};

export default YearDropdown;